import { getCustomerDetailsById,
  getPolicyListingServices,
  updateCustomerDetailsService } from "../../services/customerDetailsService";
import {
    GET_CUSTOMER_DETAILS_FAILURE,
    GET_CUSTOMER_DETAILS_SUCCESS,
    START_LOADING,
  STOP_LOADING,
  UPDATE_CUSTOMER_DETAILS_FAILURE,
  UPDATE_CUSTOMER_DETAILS_SUCCESS,
  GET_POLICY_LISTING_FAILURE,

} from "./actionTypes";
import { openSessionTimeoutModal } from './sessionTimeOutActions';

export const updateCustomerDetailsAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });

    const token = getState().auth.token || sessionStorage.getItem("token"); // Removed extra semicolon

    const response = await updateCustomerDetailsService(formData, token);

    dispatch({ type: UPDATE_CUSTOMER_DETAILS_SUCCESS, payload: response });
  } catch (error) {
    if (error.response?.status === 403) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({
        type: UPDATE_CUSTOMER_DETAILS_FAILURE,
        payload: error.message || "Update Customer Details service failed. Please try again.",
      });
    }
  } finally {
    dispatch({ type: STOP_LOADING, service: 'UPDATE_CUSTOMER_DETAILS' }); // Ensures loading stops always
  }
};

export const getCustomerDetailsByIdAction = (id, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });

    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getCustomerDetailsById(id, token);

    dispatch({ type: GET_CUSTOMER_DETAILS_SUCCESS, payload: response });

    if (callbackfn) {
      callbackfn({ success: true, status: 200 });
    }

  } catch (error) {
    const status = error?.response?.status;
    const backendMessage = error?.errors?.[0]?.errorMessage; // << Updated
  const fallbackMessage = error?.message || "Something went wrong";
  const finalMessage = backendMessage || fallbackMessage;

    if (status === 403) {
      dispatch(openSessionTimeoutModal());
    }

    dispatch({
      type: GET_CUSTOMER_DETAILS_FAILURE,
      payload: finalMessage,
    });

    if (callbackfn) {
      callbackfn({ success: false, status, errorMessage: finalMessage });
    }

  } finally {
    dispatch({ type: STOP_LOADING, service: 'UPDATE_CUSTOMER_DETAILS' });
  }
};




  export const getClientCustomerId = (id) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      dispatch({ type: "GET_CUSTOMER_ID_SUCCESS", payload: id });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
    }
  };

  export const getSelectedCustomerDetails = (data) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      dispatch({ type: "GET_SELECTED_CUSTOMER_DETAILS_SUCCESS", payload: data });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'ALL_SMS' });
    }
  };

  export const getPolicyListingAction = (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });

      const token = getState().auth.token || sessionStorage.getItem("token");

      const response = await getPolicyListingServices(id, token);

      dispatch({ type: "GET_POLICY_LISTING_SUCCESS", payload: response });
    } catch (error) {
      if (error.response?.status === 403) {
        dispatch(openSessionTimeoutModal());
      } else {
        dispatch({
          type: GET_POLICY_LISTING_FAILURE,
          payload: error.message || "Get Customer policy list service failed. Please try again.",
        });
      }
    }
  };
